export function JSONPrettyStringify(value: any, replacer?: (string | number)[] | null) {
    return JSON.stringify(value, replacer, 2)
}